import { createAction } from 'redux-actions';
import { ONBOARDING_ENTER, ONBOARDING_LEAVE } from '../../constants';

export const enterOnboarding = createAction(ONBOARDING_ENTER);
export const leaveOnboarding = createAction(ONBOARDING_LEAVE);
